module.exports = __webpack_public_path__ + "static/media/Console.37dd973f.png";